/* unplugin-vue-components disabled */import { render } from "./ComicsContents.vue?vue&type=template&id=6befabfb&scoped=true"
import script from "./ComicsContents.vue?vue&type=script&lang=js"
export * from "./ComicsContents.vue?vue&type=script&lang=js"

import "./ComicsContents.vue?vue&type=style&index=0&id=6befabfb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6befabfb"]])

export default __exports__